import { createRouter, createWebHistory } from "vue-router"
import { publicPath } from "../../vue.config"
import Home from "../views/Home.vue"
import Builder from "../views/Builder.vue"
import Resume from "../views/Resume.vue"
import About from "../components/resume/About.vue"
import Skills from "../components/resume/Skills.vue"
import WorkHistory from "../components/resume/WorkHistory.vue"
import Contact from "../components/resume/Contact.vue"
import Projects from "../components/resume/Projects.vue"
import ProjectDetail from "../components/resume/ProjectDetail.vue"
import NotFound from "../views/NotFound.vue"
import storageHelper from "storage-helper"
import Protected from "../views/Protected.vue"

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/builder",
    name: "Builder",
    component: Builder,
  },
  {
    path: "/resume",
    name: "Resume",
    component: Resume,
    redirect: "/resume/about",
    children: [
      {
        path: "/resume/about",
        name: "About",
        component: About,
      },
      {
        path: "/resume/skills",
        name: "Skills",
        component: Skills,
      },
      {
        path: "/resume/workhistory",
        name: "WorkHistory",
        component: WorkHistory,
      },
      {
        path: "/resume/projects",
        name: "Projects",
        component: Projects,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/resume/projects/:name",
        name: "ProjectDetail",
        component: ProjectDetail,
        props: true,
      },
      {
        path: "/resume/contact",
        name: "Contact",
        component: Contact,
      },
    ],
  },
  {
    path: "/protected",
    name: "Protected",
    component: Protected,
  },
  {
    path: "/:catchAll(.*)",
    component: NotFound,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  base: publicPath,
  routes,
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  if (to.meta.requiresAuth) {
    if (!storageHelper.getItem("user-password")) next("/protected")
    else next()
  } else next()
})

export default router
